import React, { createClass, PropTypes } from 'react';
import { Snackbar } from 'material-ui';
import { merge } from 'ramda';

const SnackBarMessage = createClass({
  propTypes: {
    open: PropTypes.bool,
  },

  getInitialState() {
    return {
      message: '',
      actionText: '',
      showSnackBar: this.props.open || false,
    };
  },

  componentWillUnmount() {
    clearTimeout(this._timer);
  },

  _timeout() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => {
      this.setState({
        showSnackBar: false,
      });
    }, 8000);
  },

  triggerSnackBarMessage(snackBarOptions) {
    if (!snackBarOptions) return;
    const stateUpdate = typeof snackBarOptions === 'string' ? { message: snackBarOptions } : snackBarOptions;
    this.setState(merge(stateUpdate, { showSnackBar: true }));
    this._timeout();
  },

  _snackBarTapped() {
    if (this.state.actionTap) {
      this.state.actionTap();
    }
    this.setState({
      actionTap: undefined,
      showSnackBar: false,
    });
  },

  render() {
    return (
      <Snackbar
        message={this.state.message}
        action={this.state.actionText}
        onActionTouchTap={this._snackBarTapped}
        open={this.state.showSnackBar}
        style={{ textAlign: 'center' }}
      />
    );
  },
});

export default SnackBarMessage;



// WEBPACK FOOTER //
// ./src/app/components/snackBarMessage.jsx